<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ getUserName() }}
        </p>
        <span class="user-status" />
      </div>
      <b-avatar
        size="40"
        variant="light-primary"
        badge
        :src="require('@/assets/images/avatars/avatar-small.png')"
        class="badge-minimal"
        badge-variant="success"
      />
    </template>

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="profile"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>{{ $t('Profile') }}</span>
    </b-dropdown-item>

    <b-dropdown-item
      v-if="isOrganization()"
      link-class="d-flex align-items-center"
      @click="settings"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>{{ $t('Org profile') }}</span>
    </b-dropdown-item>

    <b-dropdown-divider />

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ $t('Logout') }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { initialAbility } from '@/libs/acl/config'
import { isOrganization } from '@/auth/utils'
import ability from '@/libs/acl/ability'
import store from '@/store'
import jwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      userData: store.state.auth.user,
      avatarText,
    }
  },
  methods: {
    getUserName() {
      return this.userData.first_name ? this.userData.first_name : this.userData.email
    },
    getOrganizationName() {
      return this.userData.org_id ? this.$langName(this.userData.org_id.name) : null
    },
    profile() {
      this.$router.push({ name: 'me' })
    },
    settings() {
      this.$router.push({ name: 'settings' })
    },
    logout() {
      jwt.logout()
      // Reset ability
      ability.update(initialAbility)
      // Redirect to login page
      if (this.$route.name !== 'main-page') this.$router.push({ name: 'main-page' })
      else this.$router.go(0)
    },
  },
  setup() {
    return {
      isOrganization,
    }
  },
}
</script>
